import React, { useEffect } from "react";
import { Button, Grid, Header, Icon } from "semantic-ui-react";
import useCustomerView from "../../hooks/useCustomerView";
import CustomerReviewsTable from "@common/components/shared/CustomerReview/CustomerReviewsTable";
import CustomerReviewFiltersDesktop from "@common/components/shared/CustomerReview/CustomerReviewFiltersDesktop";
import useReviews from "@common/components/hooks/useReviews";
import useCustomerReviewsFilters from "../../common/components/hooks/useCustomerReviewsFilters";
import useCustomerReview from "../../common/components/hooks/useCustomerReview";

const CustomerReviews = () => {
  const {
    selectedCustomer,
    activeViewTab,
    reviewsColumns,
    customerReviews,
    fullName,
    getCustomerReviews,
  } = useCustomerView();
  const { selectedReview, onCustomerReviewClick } = useReviews();
  const { showFilters, toggleFilters } = useCustomerReviewsFilters();
  const { open, setReviewModalState } = useCustomerReview();

  useEffect(() => {
    if (!selectedCustomer || activeViewTab !== 3 || open) return;
    getCustomerReviews(selectedCustomer?.customer?.id);
  }, [selectedCustomer, activeViewTab, open]);

  return (
    <Grid className="pt-1 w-100">
      <Grid.Row className="flex-row-center">
        <Header className="pt-1 pl-1">{fullName} - Reviews</Header>
        <Button
          onClick={() =>
            setReviewModalState({ open: true, selectedReview: null })
          }
        >
          + Add Manual Review
        </Button>
        <Button
          onClick={() => setReviewModalState({ open: true })}
          disabled={!selectedReview}
        >
          Review Details
        </Button>
        <Button
          type="button"
          onClick={toggleFilters}
          color={showFilters ? "black" : ""}
          inverted={!showFilters}
          className="w-3 h-3 p-0 m-0 border"
        >
          <Icon
            style={{ padding: "0 0 0 0.35em" }}
            name="sliders horizontal"
            color={showFilters ? "" : "black"}
            size="large"
          />
        </Button>
      </Grid.Row>
      <CustomerReviewFiltersDesktop />
      <CustomerReviewsTable
        headings={reviewsColumns}
        records={customerReviews}
        selectedReview={selectedReview}
        onCustomerReviewClick={onCustomerReviewClick}
      />
    </Grid>
  );
};
export default CustomerReviews;
